import { Provider } from "@angular/core";
import { provideDataLoad } from "@tylertech/data-load-module";
import { provideNotes } from "@tylertech/notes-module";
import { InfoCardService } from "./services";

export function provideInfoCard(): Array<Provider>
{
    return [
        provideDataLoad(),
        provideNotes(),
        InfoCardService,
    ];
}
